// Auto-detect environment: use localhost for local dev, server for production
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// In production, nginx routes /api/ to Django, so we use the same origin
// In local dev, connect directly to Django on port 8000
export const API = isLocalhost 
  ? "http://127.0.0.1:8000/api" 
  : `${window.location.protocol}//${window.location.hostname}/api`;